import Link from "next/link";

import Heading from "@components/Heading";
import ResponsiveShopBanner from "@components/ShopInShop/ResponsiveShopBanner";
import CategoriesList from "@components/ShopInShop/CategoriesList";
import ArrowRightIcon from "@components/Icons/ArrowRight";
import { getSlug } from "@lib/helpers";

const Category = ({ category }) => {
  const hasTopBanner = category.banners.find(
    (banner) => banner.position === "top"
  );
  const hasBottomBanner = category.banners.find(
    (banner) => banner.position === "bottom"
  );

  return (
    <div id={getSlug(`gama-produse-${category.slug}`)}>
      {hasTopBanner && (
        <div className="mb-[60px] rounded-tr-[10px] rounded-bl-[10px] md:rounded-tr-[20px] md:rounded-bl-[20px] overflow-hidden">
          <ResponsiveShopBanner banner={hasTopBanner} />
        </div>
      )}

      <div className="flex justify-between items-center mb-[20px]">
        {category.name && (
          <Heading
            title={category.name}
            as="h2"
            classesProp="text-[24px] md:-text-[32px] -tracking-[0.66px] leading-normal"
          />
        )}

        <div className="hidden md:block">
          <Link href={category.url}>
            <a
              className="flex items-center gap-[4px] text-[14px] font-medium -tracking-[0.19px]"
              title=""
            >
              Vezi intreaga gama de produse <ArrowRightIcon />
            </a>
          </Link>
        </div>
      </div>

      <CategoriesList categories={category.children} />

      <div className="md:hidden flex justify-center mt-[30px]">
        <Link href={category.url}>
          <a
            className="flex items-center gap-[4px] text-[14px] font-medium -tracking-[0.19px]"
            title=""
          >
            Vezi intreaga gama de produse <ArrowRightIcon />
          </a>
        </Link>
      </div>

      {hasBottomBanner && (
        <div className="mt-[60px] rounded-tr-[10px] rounded-bl-[10px] md:rounded-tr-[20px] md:rounded-bl-[20px] overflow-hidden">
          <ResponsiveShopBanner banner={hasBottomBanner} />
        </div>
      )}
    </div>
  );
};

export default Category;
